module.exports = __webpack_public_path__ + "img/3_65.ef7b7023.png";